//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_USUARIOS_ADMINISTRADORES = "obtenerUsuariosAdministradores";
export const OBTENER_USUARIO_INSTITUCION = "obtenerUsuarioAdministrador";
export const REGISTRAR_USUARIO_ADMINISTRADOR = "registrarUsuarioAdministrador";
export const ACTUALIZAR_USUARIO_INSTITUCIONAL = "actualizarUsuarioAdministrador";


// mutation types
export const SET_USUARIOS_ADMINISTRADORES = "setUsuariosAdministradores";
export const SET_USUARIO_ADMINISTRADOR = "setUsuarioAdministrador";



const state = {
   usuariosAdministradores: [],
   usuarioAdministrador: []
}

const getters = {
    obtenerUsuariosAdministradores(state) {
      return state.usuariosAdministradores;
    },

   
}

const actions = {
    async [OBTENER_USUARIOS_ADMINISTRADORES](context, institucionId) {

        
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuarios/Rol/${6}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_ADMINISTRADORES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    


    async [OBTENER_USUARIO_INSTITUCION](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Usuarios/`)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_ADMINISTRADOR, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_USUARIO_ADMINISTRADOR](context, datosUsuario){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios`, datosUsuario)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_ADMINISTRADOR, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_USUARIO_INSTITUCIONAL](context, datosUsuarioInstitucional){
        let id = datosUsuarioInstitucional.id;
        
        return new Promise(resolve => {
            ApiService.update(`apiconsume/update/${id}?endpoint=api/Usuarios/`, datosUsuarioInstitucional)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_ADMINISTRADOR, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },



  
    


}

const mutations = {
    [SET_USUARIOS_ADMINISTRADORES](state, data) {
        state.usuariosAdministradores = data;
    },

    [SET_USUARIO_ADMINISTRADOR](state, data) {
        state.usuarioAdministrador = data;
    }

    
}


export default {
    state,
    getters,
    actions,
    mutations
}